$(document).ready(function() {
	$('.js-mobile-menu').click(function() {
		$(this).toggleClass('is-active');
        $('.primary__nav').toggleClass('is-open');
        $('body').toggleClass('is-fixed');
        $('.logo-menu').toggleClass('is-fixed');
        
        //Focus in the menu if opening
        if ($('.primary_nav').hasClass('is-fixed')) {
            $('.primary_nav').focus();
        } else {
            $('.primary_nav').blur();
        }
	});
    
    $('.js-submenu').click(function() {
		$(this).siblings('.primary__nav__submenu').toggleClass('is-open');
	});
});